<template>
  <div class="learning-path-details">
    <LoadingSpinner class="learning-path-details__spinner" v-if="!difficulty" />
    <div class="learning-path-details__content" v-if="difficulty">
      <div class="learning-path-details__section-title">
        <span>Learning Path</span>
      </div>
      <div class="learning-path-details__title">
        Getting Started in {{ title }}
      </div>
      <div class="learning-path-details__item-wrapper">
        <div class="learning-path-details__item">
          <span>DIFFICULTY</span>
          <div class="learning-path-details__item--difficulty">
            <Difficulty
              :difficulty="difficulty"
              :alwaysVisible="true"
              :colored="true"
            />
          </div>
        </div>
        <div class="learning-path-details__item" v-if="duration">
          <span>DURATION</span>
          <span>{{ duration }}</span>
        </div>
        <div class="learning-path-details__item" v-if="sections">
          <span>SECTIONS</span>
          <span>{{ sections }}</span>
        </div>
        <div class="learning-path-details__item" v-if="courses">
          <span>COURSES</span>
          <span>{{ courses }}</span>
        </div>
        <div class="learning-path-details__item" v-if="videos">
          <span>VIDEOS</span>
          <span>{{ videos }}</span>
        </div>
        <div class="learning-path-details__item" v-if="quizzes">
          <span>QUIZZES</span>
          <span>{{ quizzes }}</span>
        </div>
        <div class="learning-path-details__item" v-if="labs">
          <span>LABS</span>
          <span>{{ labs }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Difficulty from '@/components/properties/Difficulty.vue'
import LoadingSpinner from '@/components/loaders/LoadingSpinner.vue'

export default {
  name: 'LPDetails',
  components: {
    Difficulty,
    LoadingSpinner,
  },
  computed: {
    ...mapState({
      learningPath: state => state.learningPaths.currentLearningPath,
    }),
  },
  data() {
    return {
      difficulty: '',
      duration: '',
      sections: '',
      courses: '',
      videos: '',
      quizzes: '',
      labs: '',
    }
  },
  methods: {
    async queryData(pathId) {
      this.difficulty = ''
      try {
        const learningPath = await this.$store.dispatch(
          'learningPaths/getSelectedStarterPassLearningPath',
          pathId
        )
        this.difficulty = (await learningPath).difficulty
        this.duration = this.$duration.getCourseDuration({
          duration: this.$duration.hhmmss(
            (await learningPath).duration_in_seconds || '0'
          ),
        })
        this.sections = (await learningPath).summary.total_groups.toString()
        this.courses = (await learningPath).summary.total_courses.toString()
        this.videos = (await learningPath).summary.total_videos.toString()
        this.quizzes = (await learningPath).summary.total_quizzes.toString()
        this.labs = (await learningPath).summary.total_labs.toString()
      } catch (error) {
        console.error(`Error! Could not reach the API. ${error}`)
      }
    },
  },
  created() {
    if (this.pathId) {
      this.queryData(this.pathId)
    }
  },
  props: {
    pathId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.learning-path-details {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  margin-bottom: 30px;
  background: linear-gradient(270deg, transparent -100%, var(--dark-gray) 30%);
  height: 370px;
  @include tablet {
    width: 260px;
    height: 390px;
  }
  @include desktop {
    width: 305px;
    height: 370px;
  }
  &__spinner {
    margin: unset;
    background-color: unset;
    z-index: unset;
    display: flex;
    justify-content: center;
    flex-flow: column;
  }
  &__section-title {
    width: 140px;
    height: 35px;
    background: var(--oranger-gradient);
    clip-path: polygon(0 0, 100% 0, 90% 100%, 0% 100%);
    border-radius: 10px 0 0 0;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    flex-flow: column;
    span {
      margin-left: 20px;
    }
  }
  &__title {
    font-family: var(--font-bold);
    font-size: 18px;
    line-height: 24px;
    align-self: flex-start;
    margin-left: 20px;
    max-width: 265px;
  }
  &__item {
    &-wrapper {
      width: 100%;
      padding: 0 20px;
    }
    border-block-end: 1px solid var(--tundora-gray);
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    align-items: center;
    padding: 10px 0;
    color: var(--mid-gray);
    &:last-child {
      border-block-end: none;
    }
  }
}
</style>
